<template>
  <div class="mb-7">
    <h5 v-if="label" class="mr-1 mb-1">{{ label }}</h5>
    <ckeditor
      editor-url="ckeditor/ckeditor.js"
      :config="editorConfig"
      :value="value"
      @input="$emit('input', $event)"
      @ready="editorReady"
    ></ckeditor>

    <span
      v-if="Array.isArray(errors)"
      class="d-block mt-2 pr-1 error--text"
    >{{ errors.join(' | ') }}</span>
  </div>
</template>


<script>
export default {
  name: 'editor',
  props: ['label', 'value', 'errors'],

  data: function () {
    return {
      editorConfig: {
        language: 'ar',
        toolbar: [
          { name: 'document', items: ['Source', '-', 'Preview'] },
          { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
          { name: 'editing', items: ['Find', 'Replace', '-', 'SelectAll'] },
          { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', '-', 'Superscript', 'Subscript', '-', 'CopyFormatting', 'RemoveFormat'] },
          '/',
          { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl'] },
          { name: 'links', items: ['Link', 'Unlink', 'Anchor'] },
          { name: 'insert', items: ['Image', 'VideoEmbed','Table', 'HorizontalRule', 'SpecialChar'] },
          '/',
          { name: 'styles', items: ['Format', 'Font', 'FontSize'] },
          { name: 'colors', items: ['TextColor', 'BGColor'] },
          { name: 'tools', items: ['Maximize', 'ShowBlocks'] },
        ],

        font_names: 'Traditional Arabic;'
          + 'Amiri;'
          + 'Helveticaneuelt;'
          + 'Arial;'
          + 'Courier New;'
          + 'Georgia;'
          + 'Lucida Sans Unicode;'
          + 'Tahoma, Geneva;'
          + 'Times New Roman;'
          + 'Trebuchet MS;'
          + 'Verdana',

        disallowedContent: 'img{width,height,float}',
        extraAllowedContent: 'iframe[*] img{align}',

        contentsCss: [
          'https://cdn.ckeditor.com/4.15.1/full-all/contents.css',
          'https://ckeditor.com/docs/ckeditor4/4.15.1/examples/assets/css/pastefromword.css',
          'ckeditor/style.css'
        ],

        extraPlugins: 'uploadwidget,uploadimage,uploadfile,pastefromword,videoembed',

        uploadUrl: `${process.env.VUE_APP_BASE_URL}/admin/attachments/upload-image?`,
        imageUploadUrl: `${process.env.VUE_APP_BASE_URL}/admin/attachments/upload-image?`,
        filebrowserImageUploadUrl: `${process.env.VUE_APP_BASE_URL}/admin/attachments/upload-image?`,
      },
    };
  },


  methods: {
    editorReady(editor) {
      const vue = this;
      editor.on('fileUploadRequest', function(event) {
        var xhr = event.data.fileLoader.xhr;
        xhr.setRequestHeader('Authorization', `Bearer ${vue.$auth.token()}`);
      });
    }
  }
}
</script>
